import styled, { css, keyframes } from 'styled-components';
import { Card, Image } from 'antd';
const isMobile = window.innerWidth < 768;


interface StyledCardProps {
  screens: {
    xs?: boolean;
    sm?: boolean;
    md?: boolean;
    lg?: boolean;
    xl?: boolean;
    xxl?: boolean;
  };
}

const pulse = keyframes`
  0% { transform: scale(1); }
  50% { transform: scale(1.015); }
  100% { transform: scale(1); }
`;

export const StyledGameContainer = styled.div`
  
  .game {
    position: relative;
    margin-top: 16px;
    box-shadow: 0 1px 4px 0 rgba(12, 12, 13, 0.1);
    border-radius: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 600px;
    
    .game-image{
      height: 100%;
      width: 100%;
      position: absolute;
    }
    
    .audio-container{
      position: absolute;
      left: 0;
      bottom: 0;
    }
    
    .game-body{
      position: relative;
      z-index: 5;
    }

    .placeholder {
      transition: background-color 0.2s;
    }

    .placeholder.hover {
      background-color: #f0f0f0;
    }
    
    .background-image{
      border-radius: 20px;
      position: absolute;
      top: -16px;
    }
    
    .task-images, .choice-images{
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
`

export const ImageWrapper = styled.div<StyledCardProps>`
  .ant-image {
    width: 100% !important;
    height: ${({ screens }) => {
      const isTablet = screens.md && !screens.xl && !screens.xxl;
      if (isTablet) return '800px';
      if (screens.xs) return '450px';
      if (screens.xxl) return '600px';
      return '500px';
    }};
    display: block;
  }

  .ant-image-img {
    object-fit: cover;
    height: 100% !important;
    width: 100% !important;
  }
`;

export const ButtonContainer = styled.div`
  background-color: white;
  width: ${isMobile ? '38px' : '48px'};
  height: ${isMobile ? '38px' : '48px'};
  border-radius: 50%;
  border: 2px solid rgba(229, 233, 242, 1);
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: background-color 0.3s;

  &:hover {
    background-color: rgba(0, 189, 244, 1);
    & svg {
      color: #fff;
    }
  }
`;

export const StyledImage = styled(Image)<{ isPlaying: boolean }>`
  transition: transform 0.3s ease;
  ${({ isPlaying }) =>
    isPlaying &&
    css`
      animation: ${pulse} 1.5s infinite ease-in-out;
    `}
`;

export const StyledCard = styled(Card)<StyledCardProps>`
  .ant-card-body{
  height: ${({ screens }) => (screens.xs ? 'auto' : '100%')};
  }
`;